import CustomInput from "@/components/CustomInput/CustomInput.vue";
import InfoMessage from "@/components/AlertMessage/InfoMessage.vue";
export default {
    name: 'ChangePassword',
    components: {CustomInput, InfoMessage},
    data() {
        return {
            cPassword: '',
            nPassword: '',
            cnPassword: '',
            equally: false,
            error: false,
            errorSubmit: false,
            success: false,
            errorReport: '',
            messageNotMatch: '',
            isBlockBtn: true,
        }
    },
    methods: {
        disabledFormChangePassword() {
            document.getElementById('confirm_change_password').click();
            return false;
        },
        currentPassword(data) {
            this.errorSubmit = false
            this.cPassword = data.inp
            this.blockButtonListener()
        },
        newPassword(data) {
            this.errorSubmit = false
            this.nPassword = data.inp
            this.blockButtonListener()
        },
        repeatPassword(data) {
            this.errorSubmit = false
            this.cnPassword = data.inp
            this.blockButtonListener()
        },
        async submit() {
            if (this.passwordsChecker()) {
                this.isBlockBtn = true;
                const result = await this.$store.dispatch('changePassword', {
                    password: this.cPassword,
                    new_password: this.nPassword
                })
                if (result.success) {
                    this.success = true
                    this.error = false
                } else {
                    this.success = false
                    this.error = true
                    this.errorReport = result.error
                }
            } else {
                this.errorSubmit = true
            }
        },
        passwordsChecker() {
            return (this.nPassword.trim().length > 0 && this.cnPassword.trim().length > 0) &&
                (this.nPassword === this.cnPassword) &&
                (this.cPassword.trim().length > 0)
        },
        blockButtonListener() {
            if (this.passwordsChecker()) {
                this.isBlockBtn = false;
            } else {
                this.isBlockBtn = true;
            }
        }
    },
    computed: {
        matching () {
            return this.cnPassword !== this.nPassword
        },
        blockButton() {
            return true
        },
        showMessageNotMatch() {
            if (this.matching && this.cnPassword.length > 0) {
                return 'The password confirmation does not match.'
            }
        }
    }
}
